import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { CreditCard } from '@one-thd/sui-icons';
import { PRO_TRADE_CREDIT_IMG_SRC } from '@src/assets/images/ProTradeCreditImgData';
import { useReturnStore } from '@src/stores/returnStore';
import { returnCCImage } from '../../utils/cc-images';
import { ITender } from '../../models/common';

// Shorten to MM/YY
const shortenedExpDate = (expDate?: string) =>
  expDate && `${expDate?.slice(0, 2)}/${expDate?.slice(5)}`;

export const renderCardTypeLogic = (cards: ITender[]) => {
  // Slicing list to only first card for now as we are not supporting multiple card types, we'll remove this line once multiple cards are supported
  const singleCardList = cards?.slice(0, 1) || [];

  return singleCardList?.map((tender, index: number) => {
    const { type } = tender;
    if (type && returnCCImage(type, 28, 43)) {
      return (
        <div
          data-qm-mask=""
          key={index}
          className="sui-flex sui-justify-center sui-gap-2"
        >
          <div>{returnCCImage(type, 28, 43)}</div>
        </div>
      );
    }
    return null;
  });
};

export const GuestRefundMethod = () => (
  <div className="sui-flex">
    <CreditCard />
    &nbsp;
    <div className="sui-flex sui-mx-4">
      <Typography>Original Payment Method</Typography>
    </div>
  </div>
);

interface NonGuestRefundMethodProps {
  tenders: ITender[];
  expDate?: string;
}

export const NonGuestRefundMethod = ({
  tenders,
  expDate,
}: NonGuestRefundMethodProps) => {
  const ptcNickname = useReturnStore((state) => state.ptcNickname);
  const isPTCOrder = useReturnStore((state) => state.isPTCOrder);

  if (isPTCOrder) {
    return (
      <div className="sui-flex sui-gap-3 sui-flex-col">
        <div className="sui-flex sui-gap-2">
          <div className="sui-flex sui-items-end">
            <Typography weight="bold">Payment:</Typography>
          </div>
          <div className="sui-flex sui-items-end">
            <img
              height={21}
              width={80}
              alt="pro-trade-credit"
              src={PRO_TRADE_CREDIT_IMG_SRC}
            />
          </div>
          <div>
            <Typography variant="body-lg">****{tenders?.[0]?.value}</Typography>
          </div>
        </div>
        {ptcNickname && ptcNickname.trim().length > 0 && (
          <div className="sui-flex sui-gap-2">
            <Typography weight="bold">Line of Credit:</Typography>
            <Typography>{ptcNickname}</Typography>
          </div>
        )}
      </div>
    );
  }

  const displayedDate = shortenedExpDate(expDate);
  return (
    <div className="sui-flex">
      {renderCardTypeLogic(tenders)}&nbsp;
      <div className="sui-flex sui-mx-4">
        <Typography variant="body-lg">
          <sup>****</sup>
        </Typography>
        <Typography>{tenders?.[0]?.value}</Typography>
      </div>
      {displayedDate && <Typography>Exp {displayedDate}</Typography>}
    </div>
  );
};
